const getRandomNumber = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};

const randomNumber = getRandomNumber(7, 28);
const spanToInsert = document.createElement('span');
spanToInsert.classList.add('person-counter');
const personCounterText = `Sei schnell! ${randomNumber} Personen haben dieses Produkt gerade in ihrem Warenkorb 🔥`;
spanToInsert.textContent = personCounterText;

const observer = new MutationObserver((_, obs) => {
    const productForm = document.getElementById('tee-artwork-form');
    const price = productForm?.querySelector('.tee-product-price');

    if (!price || !productForm) return;

    const countDown = document.querySelector('.product-form__countdown');
    const stockBar = document.querySelector('.product-form__stock-bar');
    const cta = document.querySelector('#teeAtcButton');
    const qtyBreaks = document.querySelector('.quantity-breaks__wrapper');
    const formActions = productForm.querySelector('#teeFormActions');
    const formInputs = productForm.querySelector('#teeFormInputs');
    const titlePriceV2 = document.querySelector('.product__title--with-price');
    const iconsWithText = document.querySelectorAll('.product__icon--with-text');
    const delmWidget = document.querySelector('delm-widget');

    if (qtyBreaks) formActions.insertAdjacentElement('beforebegin', qtyBreaks);
    if (stockBar) price.insertAdjacentElement('afterend', stockBar);
    if (countDown) price.insertAdjacentElement('afterend', countDown);
    if (titlePriceV2) {
      const innerPrice = titlePriceV2.querySelector('.money');
      price.insertAdjacentElement('beforebegin', titlePriceV2);
      innerPrice.replaceWith(price);
      const inputsTitle = document.createElement('div');
      inputsTitle.classList.add('formInputsTitle');
      inputsTitle.textContent = 'Configurer le produit';
      formInputs.insertAdjacentElement('beforebegin', inputsTitle);
    }
    if (cta) cta.insertAdjacentElement('afterend', spanToInsert);

    const productTitle = document.querySelector('.ProductMeta__Title');
    const ribbon = document.querySelector('.ribbon-with-tooltip');
    if (ribbon) productTitle.insertAdjacentElement('beforebegin', ribbon);
    
    const container = productForm.closest('.Container');
    if (container) {
        const productTitle = document.querySelector('.ProductMeta__Title');
        const ribbon = document.querySelector('.ribbon-with-tooltip');
        if (ribbon) productTitle.insertAdjacentElement('beforebegin', ribbon);
        
    }
    
    if (iconsWithText.length > 0 && delmWidget) {
        iconsWithText.forEach((iconWithText) => {
            delmWidget.insertAdjacentElement('afterend', iconWithText);
        });
    }

    obs.disconnect();
});

observer.observe(document, {
    childList: true,
    subtree: true
});